module.exports = __webpack_public_path__ + "img/Evaluation.580bdf1b.svg";